export default __webpack_public_path__ + "static/media/icon.8910c56f.PNG";